export default {
  hidden: true,
  name: 'Project Title',
  shareMode: true,
  premium: false,
  builderComponent: () => import('@/components/Builder/FlowBuilder'),
  landingComponent: () => import('@/components/Builder/FlowViewer'),
  reportComponent: () => import('@/components/Builder/Report/BuilderExperienceReport'),
  icon: require('@/assets/images/test-builder/custom-page-icon.svg'),
  rawIcon: require('@/assets/images/icons/test-methods/custom-page-icon.svg'),
  backgroundColor: '#e7f7ff',
  emojicon: '📝',
  summaryStats: ['pageViews', 'completions', 'completionRate', 'interactions']
}
